import { roles } from "shared/constants/Constants.js";

const driverRoutes = {
  dashboard: [
    {
      path: "driver_list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "driver-list" */
          "../../feature/driver/dashboard/DriverPartners.js"
        ),
      authorized: [
        roles.ADMIN,
        roles.VERIFICATION,
        roles.HUB_MANAGER,
        roles.ONBOARDING,
        roles.FINANCE,
        roles.PARKING,
        // roles.RECOVER_AGENT,
        roles.SENIOR_DRIVER_MANAGER,
        roles.COMMERCIAL,
        roles.TELECALLING,
      ],
      sidebarGroup: "driverList",
      sidebarLabel: "List",
      countKey: "total_drivers",
    },
    {
      path: "dm_driver_list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "dm_driver_list" */
          "../../feature/driver/dashboard/DriverPartners2.js"
        ),
      authorized: [roles.DRIVER_MANAGER],
      sidebarLabel: "List",
      sidebarGroup: "driverList",
    },
    {
      path: "vendor_driver_list",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "vendor-driver-list" */
          "../../feature/driver/dashboard/DriverTable.js"
        ),
      authorized: [roles.VENDOR],
      sidebarLabel: "List",
      sidebarGroup: "driverList",
    },
    {
      path: "work_hold",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "in-workshop" */
          "../../feature/driver/dashboard/InWorkshop.js"
        ),
      authorized: [roles.ADMIN, roles.HUB_MANAGER, roles.DRIVER_MANAGER],
      sidebarGroup: "driverList",
      sidebarLabel: "W/S Hold",
      countKey: "in_workshop",
    },
    {
      path: "work_hold_fm",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "in-workshop-fm" */
          "../../feature/driver/dashboard/InWorkshop.js"
        ),
      authorized: [roles.FLEET_MANAGER, roles.FLEET_GENERAL_MANAGER],
      sidebarGroup: "parkingList",
      sidebarLabel: "W/S Hold",
      countKey: "in_workshop",
    },
    {
      path: "transactions",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "transactions" */
          "../../feature/driver/dashboard/Transactions.js"
        ),
      authorized: [
        roles.HUB_MANAGER,
        roles.ADMIN,
        roles.FINANCE,
        roles.SENIOR_DRIVER_MANAGER,
        roles.COMMERCIAL,
      ],
      sidebarGroup: "driverList",
      sidebarLabel: "Transactions",
      countKey: "transaction_list_count",
    },
    {
      path: "whatsapp_broadcast",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "whatsapp-broadcast" */
          "../../feature/driver/dashboard/WhatsappMessageSend.js"
        ),
      authorized: [roles.HUB_MANAGER, roles.ADMIN],
      sidebarGroup: "driverList",
      sidebarLabel: "WA Blast",
    },
    {
      path: "requests_returndriver",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "return-driver-list" */
          "../../feature/driver/dashboard/ReturnDriverTable.js"
        ),
      authorized: [],
    },
    {
      path: "dropOff_update_form",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "drop-off-date-update-form" */
          "../../feature/driver/driver-details-screen/DropOffDateUpdateForm.js"
        ),
      authorized: [roles.DRIVER_MANAGER, roles.HUB_MANAGER],
      sidebarGroup: "requestList",
      sidebarLabel: "DropOff Date Update",
    },

    {
      path: "sd_discount",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "sd-discount" */
          "../../feature/driver/SdDiscount.js"
        ),
      authorized: [roles.ADMIN, roles.HUB_MANAGER],
      sidebarGroup: "requestList",
      sidebarLabel: "SD Discount",
      countKey: "sd_discount_count",
    },
  ],
  standalone: [
    {
      path: "/settlement/collection-settlement",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "collection-driver-table" */
          "../../feature/driver/dashboard/CollectionDriverTable.js"
        ),
      protected: true,
    },
    {
      path: "/payment-history-driver/:driverAccountId",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "driver-hisab" */
          "../../feature/driver/dashboard/DriverHisab.js"
        ),
      protected: true,
    },
    {
      path: "secondary-driver-details-edit/:driverID/:secondaryDriverId",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "secondary-driver-details-edit" */
          "./driver-details-screen/secondaryDriver/SecondaryDriverDetailsScreen.js"
        ),
      protected: true,
    },
    {
      path: "/driver-details-edit/:driverID",
      lazyComponent: () =>
        import(
          /* webpackChunkName: "driver-details-screen-main" */
          "./driver-details-screen/DriverDetailsScreenMain.js"
        ),
      protected: true,
    },
  ],
};

export default driverRoutes;
